import axios from '@fs/zion-axios'

const BASE_QUEUES_PATH = '/service/dmc/dmqueues'

export function getQueues({ state, category } = {}) {
  const params = new URLSearchParams()
  if (state !== undefined) params.append('state', state)
  if (category !== undefined) params.append('category', category)
  return axios.get(`${BASE_QUEUES_PATH}?${params}`)
}

export function getQueueByName(queueName, includeCount) {
  let url = `${BASE_QUEUES_PATH}/${encodeURIComponent(queueName)}`
  if (includeCount !== undefined) {
    url += `?includeCount=${includeCount}`
  }
  return axios.get(url)
}

export function getQueueMessages({ queueName, params = {} }) {
  const url = `${BASE_QUEUES_PATH}/${encodeURIComponent(queueName)}/messages`
  const searchParams = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => searchParams.append(key, v))
    } else if (value !== undefined && value !== null) {
      searchParams.append(key, value)
    }
  })
  return axios.get(url, { params: searchParams })
}

export function getMessageById(id) {
  return axios.get(`${BASE_QUEUES_PATH}/messages/${encodeURIComponent(id)}`)
}

export function deleteMessageById(id, resolution) {
  return axios.post(`${BASE_QUEUES_PATH}/messages/${encodeURIComponent(id)}/resolve`, { resolution })
}

export function deleteMessagesBulk(messageIds, resolution) {
  return axios.post(`${BASE_QUEUES_PATH}/messages/resolve`, { messageIds, resolution })
}

export function getRecentlyResolvedMessages(queueName, count) {
  const params = {}
  if (queueName) params.queueName = queueName
  if (count) params.count = count
  return axios.get(`${BASE_QUEUES_PATH}/messages/recently-resolved`, { params })
}
